"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _getAcronym = _interopRequireDefault(require("./utils/getAcronym"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\theight: ", "px;\n\twidth: ", "px;\n\tflex: 0 0 ", "px;\n\tmax-width: ", "px;\n\tborder-radius: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: ", "em;\n\tcolor: ", ";\n\tobject-fit: cover;\n\tobject-position: center center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var CustomIcon = _styledComponents.default.img(_templateObject(), _colors.default.primary, function (props) {
  return props.iconSize;
}, function (props) {
  return props.iconSize;
}, function (props) {
  return props.iconSize;
}, function (props) {
  return props.iconSize;
}, function (props) {
  return props.fontSize;
}, _colors.default.white);

CustomIcon.displayName = 'CustomIcon';
var DefaultIcon = CustomIcon.withComponent('div');
DefaultIcon.displayName = 'DefaultIcon';

var Avatar = function Avatar(_ref) {
  var employeeName = _ref.employeeName,
      employeeImageHref = _ref.employeeImageHref,
      iconSize = _ref.iconSize,
      fontSize = _ref.fontSize,
      rest = _objectWithoutPropertiesLoose(_ref, ["employeeName", "employeeImageHref", "iconSize", "fontSize"]);

  var acronym = (0, _getAcronym.default)(employeeName);
  return employeeImageHref ? _react.default.createElement(CustomIcon, _extends({}, rest, {
    iconSize: iconSize,
    fontSize: fontSize,
    src: employeeImageHref,
    title: employeeName + "'s profile picture",
    alt: employeeName + "'s profile picture"
  })) : _react.default.createElement(DefaultIcon, _extends({}, rest, {
    iconSize: iconSize,
    fontSize: fontSize
  }), acronym);
};

Avatar.displayName = 'Avatar';
Avatar.propTypes = {
  employeeName: _propTypes.string.isRequired,
  employeeImageHref: _propTypes.string,
  iconSize: _propTypes.number,
  fontSize: _propTypes.number
};
Avatar.defaultProps = {
  employeeImageHref: undefined,
  iconSize: 70,
  fontSize: 1.2
};
var _default = Avatar;
exports.default = _default;